export enum DeliveryStatus {
  Draft = 1,
  /*
   * Confirmed is 2 and Sent is 3 because that is the order they happen in: an
   * order is drafted, confirmed with the customer, then sent to a courier.
   *
   * The numbers are not cosmetic here. The Orders page builds its tab strip
   * from DeliveryStatusLabels, and JavaScript walks integer-like keys in
   * ascending numeric order — so the tab order IS this order, whatever order
   * the labels are written in below. These used to be the other way round,
   * which is why the tabs read "Draft, Sent, Confirmed".
   *
   * Must stay in step with the PHP enum. The backend migration
   * 2026_09_21_000008 moved the existing rows to match.
   */
  Confirmed = 2,
  Sent = 3,
  Handover = 4,
  Delivered = 5,
  Partial = 6,
  PendingReturn = 7,
  Returned = 8,
  Cancelled = 9,
  PendingCancel = 10,
  Lost = 11,
  /**
   * Someone has the returned parcel in their hands again. `Returned` is only a
   * courier saying one is on its way back — this is the arrival, and the only
   * status that puts stock back.
   */
  ReturnReceived = 12,
}

export const DeliveryStatusLabels: Record<DeliveryStatus, string> = {
  [DeliveryStatus.Draft]: "Draft",
  [DeliveryStatus.Sent]: "Sent",
  [DeliveryStatus.Confirmed]: "Confirmed",
  [DeliveryStatus.Handover]: "Handover",
  [DeliveryStatus.Delivered]: "Delivered",
  [DeliveryStatus.Partial]: "Partial",
  [DeliveryStatus.PendingReturn]: "Pending Return",
  [DeliveryStatus.Returned]: "Returned",
  [DeliveryStatus.Cancelled]: "Cancelled",
  [DeliveryStatus.PendingCancel]: "Pending Cancel",
  [DeliveryStatus.Lost]: "Lost",
  [DeliveryStatus.ReturnReceived]: "Return Received",
};

export const DeliveryStatusValues: Record<string, DeliveryStatus> = {
  draft: DeliveryStatus.Draft,
  sent: DeliveryStatus.Sent,
  confirmed: DeliveryStatus.Confirmed,
  handover: DeliveryStatus.Handover,
  delivered: DeliveryStatus.Delivered,
  partial: DeliveryStatus.Partial,
  pending_return: DeliveryStatus.PendingReturn,
  returned: DeliveryStatus.Returned,
  cancelled: DeliveryStatus.Cancelled,
  pending_cancel: DeliveryStatus.PendingCancel,
  lost: DeliveryStatus.Lost,
  return_received: DeliveryStatus.ReturnReceived,
};
